import postcss from 'postcss'; // CodeAN-999 CSSParser replaced by postcss.parse - tested but functionality should be observed

//
// Transform implementation or originally thanks to
// https://github.com/raphamorim/native-css
//

function transformRules(self, rules, result) {
  rules.forEach(function (rule) {
    var obj = {};
    if (rule.type === 'atrule' && rule.name === 'media') {
      var name = mediaNameGenerator(rule.params);
      var media = (result[name] = result[name] || {
        __expression__: rule.params,
      });
      transformRules(self, rule.nodes, media);
    } else if (rule.type === 'rule') {
      rule.nodes.forEach(function (declaration) {
        if (declaration.type === 'decl') {
          var cleanProperty = cleanPropertyName(declaration.prop);
          obj[cleanProperty] = declaration.value;
        }
      });
      rule.selectors.forEach(function (selector) {
        var name = nameGenerator(selector.trim());
        result[name] = obj;
      });
    }
  });
}

var cleanPropertyName = function (name) {
  // turn things like 'align-items' into 'alignItems'
  name = name.replace(/(-.)/g, function (v) {
    return v[1].toUpperCase();
  });

  return name;
};

var mediaNameGenerator = function (name) {
  return '@media ' + name;
};

var nameGenerator = function (name) {
  name = name.replace(/\s\s+/g, ' ');
  name = name.replace(/[^a-zA-Z0-9]/g, '_');
  name = name.replace(/^_+/g, '');
  name = name.replace(/_+$/g, '');

  return name;
};

export function transform(inputCssText) {
  if (!inputCssText) {
    throw new Error('missing css text to transform');
  }

  // If the input "css" doesn't wrap it with a css class (raw styles)
  // we need to wrap it with a style so the css parser doesn't choke.
  var bootstrapWithCssClass = false;
  if (inputCssText.indexOf('{') === -1) {
    bootstrapWithCssClass = true;
    inputCssText = '.bootstrapWithCssClass { ' + inputCssText + ' }';
  }

  var css = postcss.parse(inputCssText);

  var result = {};
  transformRules(this, css.nodes, result);

  // Don't expose the implementation detail of our wrapped css class.
  if (bootstrapWithCssClass) {
    result = result.bootstrapWithCssClass;
  }

  return result;
}
